import { SxProps, Theme } from '@mui/material';

const matchModeToggleGroup: SxProps<Theme> = { height: 48 };

const matchModeToggleButton = (
  isFirst: boolean,
  isLast: boolean
): SxProps<Theme> => ({
  border: '1px solid',
  borderColor: 'primary.main',
  color: 'primary.main',
  fontSize: '16px',
  fontWeight: 600,
  lineHeight: '26px',
  letterSpacing: 0,
  px: '12px',
  py: '10px',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  ...(isFirst ? { borderTopLeftRadius: 30, borderBottomLeftRadius: 30 } : {}),
  ...(isLast ? { borderTopRightRadius: 30, borderBottomRightRadius: 30 } : {}),
  // Doubled class: MUI's own .Mui-selected rule ties on specificity.
  '&&.Mui-selected': {
    backgroundColor: 'primary.main',
    color: 'common.white',
    '&:hover': { backgroundColor: 'primary.main' }
  }
});

const chipRailBase = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  // Padding, not margin: it has to stay inside the anchored box so rows pass
  // under it rather than through the gap.
  pt: '24px',
  pb: '24px'
} as const;

const chipRail: SxProps<Theme> = chipRailBase;

// Above the table header, which anchors directly beneath it.
const anchoredChipRail: SxProps<Theme> = {
  ...chipRailBase,
  position: 'sticky',
  top: 0,
  zIndex: 11,
  backgroundColor: 'background.default'
};

// Flows as text rather than flex items, so the next chip can sit on the last
// line of one that wrapped. The line height leaves the 10px gap between lines.
const chipRailChips: SxProps<Theme> = {
  lineHeight: '38px',
  '& > *:not(:last-child)': { mr: '10px' }
};

const chipRailOrGroup: SxProps<Theme> = {
  display: 'inline-block',
  verticalAlign: 'middle',
  lineHeight: '38px',
  px: '10px',
  py: '5px',
  borderRadius: '32px',
  backgroundColor: 'primary.light',
  '& > *:not(:last-child)': { mr: '10px' }
};

const chipRailConnector: SxProps<Theme> = {
  fontFamily: 'inherit',
  fontSize: '14px',
  lineHeight: '20px',
  color: 'customGrey.dark',
  textDecoration: 'underline',
  textDecorationColor: 'currentcolor',
  verticalAlign: 'baseline'
};

const chipRailActions: SxProps<Theme> = {
  display: 'flex',
  gap: '20px',
  alignItems: 'center'
};

export const candidateFilterSx = {
  matchModeToggleGroup,
  matchModeToggleButton,
  chipRail,
  anchoredChipRail,
  chipRailChips,
  chipRailOrGroup,
  chipRailConnector,
  chipRailActions
};
